import { AccountObjectDto } from "../account-object/account-object.dto";

export class AccountStatisticsDto extends AccountObjectDto {
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.dto.ts